<template>
  <IconButton
    v-if="shouldShowWishlistButton"
    :icon="icon"
    @click="toggleWishList"
  >
    <span class="u__visually-hidden">{{ action }}</span>
  </IconButton>
</template>

<script>
import { mapState } from "vuex";

import IconButton from "@/components/IconButton.vue";
export default {
  name: "WishlistButton",
  components: {
    IconButton,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      action: "Add",
    };
  },
  computed: {
    ...mapState("auth", ["customer"]),
    ...mapState("product", ["wishlist"]),
    shouldShowWishlistButton() {
      const customerId = this.customer.id;
      if (!customerId) {
        return false;
      }

      return true;
    },
    icon() {
      if (this.action !== "Add") {
        return "heart-filled";
      }

      return "heart-path";
    },
    productInWishlist() {
      return this.wishlist.includes(this.productId);
    },
  },
  watch: {
    wishlist() {
      this.checkInitialProductState();
    },
  },
  mounted() {
    this.checkInitialProductState();
  },
  methods: {
    async toggleWishList() {
      this.apiCall();

      if (this.action === "Add") {
        this.action = "Remove";
      } else {
        this.action = "Add";
      }
    },
    apiCall() {
      const customerId = this.customer.id;
      const action = this.action.toLowerCase();

      if (!customerId) {
        return null;
      }

      fetch(
        `${process.env.RATANDBOA_NODE_APP_URL}/customer/wishlist/${action}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customerId: customerId,
            productId: this.productId,
          }),
        }
      );
    },
    checkInitialProductState() {
      if (this.productInWishlist) {
        this.action = "Remove";
      } else {
        this.action = "Add";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wishlist-button {
  font-size: 14px;
  padding: 12px;

  ::v-deep(.icon) {
    margin-right: 0;
  }
}
</style>
